import { types as t } from 'mobx-state-tree';

export const JobLabel = t.model('JobLabel', {
  id: t.number,
  color: t.string,
  title: t.string,
});
